<template>
	<div>
		<div class="answer-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">How do I go on vacation hold?</h1>

			<p v-if="is_on_hold">
				All your inventory is already on hold
			</p>
			<p v-else>
				Go into <a class="help-link" href="/account/inventory.php">your book sales</a> section and click on vacation hold or click the button below:
				<br><br>
				<v-btn color="#7DADED" large round dark @click="putOnHold" :loading="loading">Put all my items on hold</v-btn>
			</p>
		</div>

		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import BaseNavLinks from './../components/BaseNavLinks';
	import Axios from 'axios';

	export default {
		name: "VacationHold",

		components: {
			BaseNavLinks,
		},

		data() {
			return {
				is_on_hold: false,
				loading: true
			};
		},

		methods: {
			putOnHold() {
				const self = this;
				Axios.get('/service/customer_help/rest/index.php/customer_help/put_all_sales_inventory_on_hold/')
					.then(function (response) {
						if (response.status === 200 && response.data && response.data['status'] === 'success') {
							self.$router.push('/that_worked');
						}
					})
					.finally(function () {
						self.loading = false;
					});

			}
		},

		mounted() {
			const self = this;
			self.loading = true;

			Axios.get('/service/customer_help/rest/index.php/customer_help/is_inventory_on_hold/')
				.then(function (response) {
					if (response.status === 200 && response.data && response.data['status'] === 'success') {
						self.is_on_hold = response.data['data'] && response.data['data']['is_on_hold'];
					}
				})
				.finally(function () {
					self.loading = false;
				});
		},
	}
</script>

<style scoped>

</style>